import type { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material';
import type { CrmActivityDomain } from '@otw/models/leads/contacts';

/** Accent colors for sales vs inventory activity cards (not chips). */
export const CRM_ACTIVITY_DOMAIN_ACCENT: Record<CrmActivityDomain, string> = {
  sales: '#1976d2',
  inventory: '#00897b',
  marketing: '#7b1fa2',
};

export const CRM_ACTIVITY_DOMAIN_LABEL: Record<CrmActivityDomain, string> = {
  sales: 'Sales',
  inventory: 'Inventory',
  marketing: 'Marketing',
};

/**
 * Paper styling that encodes CRM side without a chip: left accent rail +
 * soft wash. Synthetic `created` entries (no domain) stay neutral.
 */
export function activityDomainPaperSx(
  domain: CrmActivityDomain | null | undefined,
): SxProps<Theme> {
  if (!domain) {
    return {
      borderRadius: 2,
      bgcolor: 'common.white',
      overflow: 'hidden',
    };
  }

  const accent = CRM_ACTIVITY_DOMAIN_ACCENT[domain];
  return {
    position: 'relative',
    borderRadius: 2,
    overflow: 'hidden',
    // Room for the absolute bottom-right domain label
    pb: 2.25,
    bgcolor: alpha(accent, 0.04),
    borderColor: alpha(accent, 0.28),
    borderLeftWidth: 3,
    borderLeftStyle: 'solid',
    borderLeftColor: accent,
    boxShadow: `inset 0 0 0 1px ${alpha(accent, 0.04)}`,
  };
}
